import { STATES } from 'common/domain/states';

export default class ManagerNavigation {

  constructor($http, $state) {
    'ngInject';
    this.http = $http;
    this.state = $state;
  }

  canNavigateToState(isManager) {
    let requiresManager = this.state.current.data.requiresManager;
    if (requiresManager && !isManager)
      this.state.go(STATES.NOT_ALLOWED);
  }

}



// WEBPACK FOOTER //
// ./client/app/common/services/managerNavigation.service.js